import React from 'react';

import styled from '@emotion/styled';
import { mq, green01, baseDurationTime } from '../../_style';
import icon from '../../assets/imgs/icon-cart.svg';
import logoAmazon from '../../assets/imgs/logo-amazon.png';
import logoLohaco from '../../assets/imgs/logo-lohaco.png';
import logoRakuten from '../../assets/imgs/logo-Rakuten.png';

const Container = styled.div`
  background-color: ${green01};
  border-radius: 2px;
  position: relative;
  a + & {
    margin-top: 15px;
  }
  span {
    display: block;
    line-height: 1;
    ${mq.ie} {
      transform: translateY(2px);
    }
  }
  ${props => props.isDisable && `opacity: 0; pointer-events: none;`}
`;

const Button = styled.button`
  color: #fff;
  display: block;
  position: relative;
  width: 100%;
  padding: 16px 0;
  font-size: 14px;
  transition: background-color ${baseDurationTime} ease, color ${baseDurationTime} ease;
  letter-spacing: 0.1em;
  ${mq.sp} {
    letter-spacing: 0.05em;
    padding-left: 18px;
    text-align: left;
  }
  ${mq.spMin} {
    font-feature-settings: "palt";
    padding-left: 0;
    padding-right: 16px;
    text-align: center;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: -2px;
    bottom: 0;
    right: 17px;
    width: 12px;
    height: 14px;
    margin: auto;
    background-image: url(${icon});
    background-position: center;
    background-size: contain;
    ${mq.spMin} {
      right: 10px;
    }
  }
`;

const Body = styled.div`
  background-color: ${green01};
  bottom: 1px;
  height: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  transform: translate3d(0, 100%, 0);
  transition: height 0.4s ease, opacity 0.4s ease;
  transition-delay: 0.2s;
  &.is-open {
    transition-delay: 0s;
  }
  z-index: 10;
`;

const Inner = styled.div`
  opacity: 0;
  padding: 10px;
  transition: opacity 0.3s ease;
  .is-open & {
    opacity: 1;
    transition-delay: 0.3s;
  }
  & > a {
    align-items: center;
    background-color: #fff;
    display: flex;
    height: 36px;
    transition: opacity 0.3s ease;
    ${mq.pc} {
      &:hover {
        opacity: 0.7;
      }
    }
    & + a {
      margin-top: 10px;
    }
    img {
      margin: auto;
      width: 58px;
    }
  }
`;

export default class BuyBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }
  componentDidUpdate() {
    if(this.state.isOpen && (this.props.openedAccordion !== this.props.activeKey)) {
      this.toggle();
    }
  }
  toggle() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
      this.body.style.height = 0;
      this.body.style.pointerEvents = 'none';
    } else {
      this.setState({ isOpen: true });
      this.body.style.height = `${this.inner.clientHeight}px`;
      this.body.style.pointerEvents = 'all';
    }
  }
  handleParentState(state) {
    if(this.props.isLarge) return;
    this.props.sendState(state);
  }
  render() {
    return (
      <Container isDisable={this.props.isDisable}
        onMouseEnter={() => {
          this.toggle();
          this.handleParentState(this.props.activeKey);
        }}
        onMouseLeave={() => {
          this.toggle();
          this.handleParentState(this.props.activeKey);
        }}>
        <Button>
          <span>{this.props.children}</span>
        </Button>
        <Body
          className={this.state.isOpen ? 'is-open' : null}
          ref={div => (this.body = div)}
        >
          <Inner ref={div => (this.inner = div)}>
            {this.props.amazonUrl && (
              <a href={this.props.amazonUrl} target="_blank">
                <img src={logoAmazon} alt="Amazon" />
              </a>
            )}
            {this.props.rakutenUrl && (
              <a href={this.props.rakutenUrl} target="_blank">
                <img src={logoRakuten} alt="Rakuten" />
              </a>
            )}
            {this.props.lohacoUrl && (
              <a href={this.props.lohacoUrl} target="_blank">
                <img src={logoLohaco} alt="Lohaco" />
              </a>
            )}
          </Inner>
        </Body>
      </Container>
    );
  }
}
